import { Link } from "react-router-dom";

export default function ServiceCard({ icon, title, desc, link }) {
  return (
    <div className="service-card">
      <div className="service-icon">
        <i className={icon}></i>
      </div>
      <h3>{title}</h3>
      <p>{desc}</p>
      <Link to={link} className="btn btn-outline">Learn More</Link>
    </div>
  );
}